import ApiService from "./ApiService";

export async function apiGetRole() {
	return ApiService.fetchData({
		url: `partner/user_role`,
		method: `get`,
	});
}
